import React, { useState, useEffect } from "react";
import axios from "axios";

import { Col, Button, Card, ProgressBar, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Chart from "react-apexcharts";

import { toast } from "react-toastify";
import { STUDENT_OVERVIEW_API } from "../../../api/api";

import bannerBg from "../../../assets/student/student-home-banner.png";
import frontend from "../../../assets/student/frontend-imgs.png";
import mern from "../../../assets/student/mern-imgs.png";
import uiux from "../../../assets/student/uiux-imgs.png";

// import HomeFrontend from "../../../assets/student/home-frontend.png";
// import HomeBackend from "../../../assets/student/home-backend.png";
import HomeFrontend from "../../../assets/publicpageimg/frontend-course.png";
import HomeBackend from "../../../assets/publicpageimg/backend-course.png";
import HomeMern from "../../../assets/student/home-mern.png";
import HomeDigital from "../../../assets/student/home-digital.png";
import HomeData from "../../../assets/student/home-data.png";
import HomeUIUX from "../../../assets/student/home-uiux.png";

// no data images
import noDataCourse from "../../../assets/student/no-data-course-watching.png";
import noDataTop from "../../../assets/student/no-data-top-learner.png";
import noDataAssignment from "../../../assets/student/no-data-assignment.png";

import { initialsFromName } from "../../../utils/getInitials";
import { handleApiError } from "../../../utils/apiErrorHandler";

import "./StudentOverview.css";

const courseSectionImages = {
  "Frontend Development": mern,
  "Backend Development": frontend,
  Backend: mern,
  MERN: uiux,
  "Digital Marketing": frontend,
  "Data Analytics": mern,
  "UI/UX": uiux,
};

const courseImages = {
  "Frontend Development": HomeFrontend,
  "Backend Development": HomeBackend,
  MERN: HomeMern,
  "Digital Marketing": HomeDigital,
  "Data Analytics": HomeData,
  "UI/UX": HomeUIUX,
};

const StudentOverview = () => {
  const navigate = useNavigate();

  const [studentName, setStudentName] = useState("");
  const [coursesSection, setCoursesSection] = useState([]);
  const [coursesWatching, setCoursesWatching] = useState([]);
  const [learningTime, setLearningTime] = useState({});
  const [lastVideo, setLastVideo] = useState({});
  const [assignments, setAssignments] = useState([]);
  const [mentors, setMentors] = useState([]);
  const [chartData, setChartData] = useState({});

  const getVisibleCount = () => {
    if (window.innerWidth <= 576) return 1;
    if (window.innerWidth <= 991) return 2;
    return 3;
  };

  // watching section js
  const getVisibleCards = () => {
    if (window.innerWidth <= 576) return 1;
    if (window.innerWidth <= 991) return 2;
    return 3;
  };

  // Carousel state
  const [visibleCount, setVisibleCount] = useState(getVisibleCount());
  const [currentIndex, setCurrentIndex] = useState(0);

  const [visibleCards, setVisibleCards] = useState(getVisibleCards());
  const [activeIndex, setActiveIndex] = useState(0);

  //loading
  const [loadingOverview, setAllOverviewLoading] = useState(true);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setAllOverviewLoading(false);
      navigate("/signin");

      return;
    }

    const fetchOverview = async () => {
      try {
        const response = await axios.post(
          STUDENT_OVERVIEW_API.GET_STUDENT_OVERVIEW,
          { student_id: userId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          const overviewData = data.data;

          setStudentName(overviewData.student_name || "");
          setCoursesSection(overviewData.course_section || []);
          setCoursesWatching(overviewData.course_watching || []);
          setLearningTime(overviewData.learningtime || {});
          setLastVideo(overviewData.last_video || {});
          setAssignments(overviewData.assignments || []);
          setMentors(overviewData.mentors || []);
          setChartData(overviewData || {});
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error("Error fetching overview:", error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        handleApiError(error, navigate, showErrorToast, "/signin");
      } finally {
        setAllOverviewLoading(false);
      }
    };

    fetchOverview();
  }, [navigate]);

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
      setVisibleCards(getVisibleCards());
      setCurrentIndex(0);
      setActiveIndex(0);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalSlides = Math.max(coursesSection.length - visibleCount + 1, 0);
  const totalDots = Math.max(coursesWatching.length - visibleCards + 1, 0);

  const slideRight = () => {
    if (currentIndex < totalSlides - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const slideLeft = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (activeIndex < totalDots - 1) {
      setActiveIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex((prev) => prev - 1);
    }
  };

  const studentProgressGraph = chartData.student_progress_graph || [];
  const radialChart = chartData.pie_chart || [];

  const courseCategories =
    studentProgressGraph?.map((item) => item.course_title) || [];

  const courseOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last",
        columnWidth: "45%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: courseCategories,
    },
    colors: ["#136AD0", "#10B981"],
    legend: {
      position: "bottom",
    },
  };

  const courseSeries = [
    {
      name: "Total Videos",
      data:
        studentProgressGraph?.map((item) => Number(item.total_videos) || 0) ||
        [],
    },
    {
      name: "Watched Videos",
      data:
        studentProgressGraph?.map((item) => Number(item.watched_videos) || 0) ||
        [],
    },
  ];

  const radialLabels = radialChart?.map((item) => item.course_title) || [];

  const totalCoursesCount = radialChart.reduce(
    (sum, item) => sum + Number(item.total || 0),
    0,
  );

  const totalCompleted = radialChart.reduce(
    (sum, item) => sum + Number(item.completed || 0),
    0,
  );

  const radialOptions = {
    chart: {
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        dataLabels: {
          name: {
            fontSize: "25px",
          },
          value: {
            fontSize: "16px",
          },
          total: {
            show: true,
            label: "Progress",
            formatter: function () {
              return `${totalCompleted} / ${totalCoursesCount}`;
            },
          },
        },
      },
    },
    labels: radialLabels,
  };

  const radialSeries = radialChart.map((item) =>
    item.total > 0 ? Math.round((item.completed / item.total) * 100) : 0,
  );

  if (loadingOverview) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <section className="student-home-section">
      <Row className="align-items-center mb-3">
        <h2 className="student-certificate-section-title">
          Welcome, {studentName}
        </h2>
        <p className="student-certificate-section-description">
          Continue your learning journey and achieve your goals with
          SkillEdition.
        </p>
      </Row>

      <Row>
        <Col lg={8} md={12}>
          <div className="justify-content-start">
            <div
              className="student-home-section-banner"
              style={{ backgroundImage: `url(${bannerBg})` }}
            >
              <h1 className="student-home-section-title">
                Shape Your Future with SkillEdition
              </h1>

              <p className="student-home-section-description">
                Learn practical skills through expert-led courses and advance
                your career at your own pace.
              </p>

              <Button
                className="student-home-section-btn"
                onClick={() => navigate("/student/courses")}
              >
                Start Learning
              </Button>
            </div>
          </div>

          <div className="student-course-section-wrapper">
            <div className="student-course-section">
              <div className="student-course-section-twocards">
                {/* Header */}
                <div className="student-course-section-header">
                  <h5 className="student-course-section-title">
                    Courses Section
                  </h5>

                  <div className="student-course-section-arrows">
                    <button
                      className="student-course-section-arrow-btn"
                      onClick={slideLeft}
                      disabled={currentIndex === 0 || totalSlides <= 1}
                      aria-disabled={currentIndex === 0 || totalSlides <= 1}
                    >
                      <FaChevronLeft />
                    </button>

                    <button
                      className="student-course-section-arrow-btn"
                      onClick={slideRight}
                      disabled={
                        currentIndex === totalSlides - 1 || totalSlides <= 1
                      }
                      aria-disabled={
                        currentIndex === totalSlides - 1 || totalSlides <= 1
                      }
                    >
                      <FaChevronRight />
                    </button>
                  </div>
                </div>

                {/* Cards */}
                <div className="student-course-section-cards">
                  <div
                    className="student-course-section-track"
                    style={{
                      transform: `translateX(-${currentIndex * (100 / visibleCount)}%)`,
                    }}
                  >
                    {coursesSection.map((course) => (
                      <div
                        key={course.course_id}
                        className="student-course-section-card"
                        onClick={() =>
                          navigate(`/student/course-videos/${course.course_id}`)
                        }
                      >
                        <div className="student-course-section-card-icon">
                          <img
                            src={
                              courseSectionImages?.[course.course_title] ||
                              frontend
                            }
                            alt={course.course_title}
                            className="student-course-section-card-icon-img"
                          />
                        </div>

                        <div>
                          <span className="student-course-section-card-progress">
                            {course.watched_videos !== undefined
                              ? `${course.watched_videos}/${course.total_videos} Watched`
                              : `${course.total_videos} Videos`}
                          </span>
                          <h6
                            className="student-course-section-card-title"
                            title={course.course_title}
                          >
                            {course.course_title}
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Dots */}
                {totalSlides > 1 && (
                  <div className="student-course-section-dots">
                    {Array.from({ length: totalSlides }).map((_, index) => (
                      <span
                        key={index}
                        onClick={() => setCurrentIndex(index)}
                        className={`student-course-section-dot ${
                          index === currentIndex
                            ? "student-course-section-dot-active"
                            : ""
                        }`}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="student-watching-section">
            {/* Header */}
            <div className="student-watching-header">
              <h5>Courses Watching</h5>

              {coursesWatching.length > 0 && (
                <div className="student-watching-arrows">
                  <button
                    onClick={handlePrev}
                    disabled={activeIndex === 0 || totalDots <= 1}
                    aria-disabled={activeIndex === 0 || totalDots <= 1}
                    className="student-watching-arrow-btn"
                  >
                    <FaChevronLeft />
                  </button>
                  <button
                    onClick={handleNext}
                    className="student-watching-arrow-btn"
                    disabled={activeIndex === totalDots - 1 || totalDots <= 1}
                    aria-disabled={
                      activeIndex === totalDots - 1 || totalDots <= 1
                    }
                  >
                    <FaChevronRight />
                  </button>
                </div>
              )}
            </div>

            {/* Cards */}
            <div className="student-watching-cards">
              {coursesWatching.length > 0 ? (
                <div
                  className="student-watching-track"
                  style={{
                    transform: `translateX(-${activeIndex * (100 / visibleCards)}%)`,
                  }}
                >
                  {coursesWatching.map((course) => (
                    <div
                      key={course.course_id}
                      className="student-watching-card"
                      onClick={() =>
                        navigate(`/student/course-videos/${course.course_id}`)
                      }
                    >
                      <img
                        src={courseImages[course.course_title] || HomeFrontend}
                        alt={course.course_title}
                        className="student-watching-image"
                      />

                      <div className="student-watching-content">
                        <span>{course.category_name}</span>
                        <h6 title={course.course_title}>
                          {course.course_title}
                        </h6>

                        <ProgressBar
                          now={course.percentage || 0}
                          className="student-learningside-progress"
                        />
                        {/* <div className="student-watching-progress-bar">
                        <span style={{ width: `${course.percentage}%` }} />
                      </div> */}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="student-watching-empty">
                  <img
                    src={noDataCourse}
                    alt="No courses"
                    className="student-watching-empty-img"
                  />
                  <p>No active courses yet</p>
                </div>
              )}
            </div>

            {totalDots > 1 && (
              <div className="student-watching-dots">
                {Array.from({ length: totalDots }).map((_, index) => (
                  <span
                    key={index}
                    className={
                      index === activeIndex
                        ? "student-watching-watch-dot active"
                        : "student-watching-watch-dot"
                    }
                    onClick={() => setActiveIndex(index)}
                  />
                ))}
              </div>
            )}
          </div>

          <div className="student-learningbar-section">
            <div className="student-learningbar-section-card">
              <h6 className="student-learningbar-section-title">
                Course Progress
              </h6>

              <div className="student-learningbar-section-chart">
                <Chart
                  options={courseOptions}
                  series={courseSeries}
                  type="bar"
                  height={260}
                />
              </div>
            </div>
          </div>
        </Col>

        <Col lg={4} md={12}>
          <div className="student-learningside-section">
            <Card className="student-learningside-card">
              <h6 className="student-learningside-title">
                Total Learning time
              </h6>

              {learningTime && Object.keys(learningTime).length > 0 ? (
                <>
                  <div className="student-learningside-timebox">
                    <div className="student-learningside-timeitem">
                      <h4 className="student-learningside-timevalue">
                        {learningTime.duration || "—"}
                      </h4>
                      <span className="student-learningside-timelabel">
                        Days
                      </span>
                    </div>

                    <div className="student-learningside-divider" />

                    <div className="student-learningside-timeitem">
                      <h4 className="student-learningside-timevalue">
                        {learningTime.total_learning_time || "0H:0M"}
                      </h4>
                      <span className="student-learningside-timelabel">
                        Time
                      </span>
                    </div>

                    <div className="student-learningside-divider" />

                    <div className="student-learningside-timeitem">
                      <h4 className="student-learningside-timevalue">
                        {learningTime.no_of_modules || "—"}
                      </h4>
                      <span className="student-learningside-timelabel">
                        Sessions
                      </span>
                    </div>
                  </div>

                  {/* Last Video */}
                  {lastVideo && Object.keys(lastVideo).length > 0 && (
                    <div className="student-learningside-lastvideo">
                      <div className="student-learningside-thumbnail">
                        <img
                          src={
                            courseImages[lastVideo.course_title] || HomeFrontend
                          }
                          alt="Last watched video"
                          className="student-learningside-thumbnail-img"
                        />
                      </div>

                      <div className="student-learningside-lastcontent">
                        <h6 className="student-learningside-videotitle">
                          Last Video
                        </h6>
                        <p
                          className="student-learningside-videodesc"
                          title={lastVideo.video_title}
                        >
                          {lastVideo.video_title || ""}
                        </p>
                        {/* <ProgressBar
                    now={65}
                    className="student-learningside-progress"
                  /> */}
                      </div>
                    </div>
                  )}

                  <Button
                    className="student-learningside-btn"
                    onClick={() =>
                      lastVideo?.course_id
                        ? navigate(
                            `/student/course-videos/${lastVideo.course_id}`,
                          )
                        : navigate("/student/courses")
                    }
                  >
                    {lastVideo?.course_id
                      ? "Continue Learning"
                      : "Start Learning"}
                  </Button>
                </>
              ) : (
                <>
                  {/* No Data Available */}
                  <div className="student-learningside-empty">
                    <img
                      src={noDataTop}
                      alt="No Learning"
                      className="student-learningside-empty-img"
                    />

                    <p className="student-learningside-empty-text">
                      Your learning stats will appear here once you start a
                      course
                    </p>

                    {/* Start Learning Button */}
                    <Button
                      className="student-learningside-btn mt-3"
                      onClick={() => navigate("/student/courses")}
                    >
                      Start Learning
                    </Button>
                  </div>
                </>
              )}
            </Card>

            {/* ASSIGNMENTS */}
            <Card className="student-learningside-card">
              <div className="student-learningside-header">
                <h6 className="student-learningside-title">Assignments</h6>
                {assignments.length > 0 && (
                  <span
                    className="student-learningside-viewall"
                    onClick={() => navigate("/student/assignments")}
                  >
                    View all
                  </span>
                )}
              </div>

              <div className="student-learningside-assignments">
                {assignments.length > 0 ? (
                  assignments.map((item, index) => (
                    <div
                      key={index}
                      className="student-learningside-assignment-item"
                    >
                      <span
                        className="student-learningside-assignment-indicator"
                        style={{
                          backgroundColor:
                            item.status?.toLowerCase() === "pending"
                              ? "#FFB020"
                              : "#28C76F",
                        }}
                      />

                      <div className="student-learningside-assignment-content">
                        <p
                          className="student-learningside-assignment-title"
                          title={item.assignment_title}
                          onClick={() => navigate("/student/assignments")}
                        >
                          {item.assignment_title}
                        </p>

                        <div className="student-learningside-assignment-meta">
                          <span
                            className={
                              item.status?.toLowerCase() === "pending"
                                ? "student-learningside-assignment-status-pending"
                                : "student-learningside-assignment-status-completed"
                            }
                          >
                            {item.status}
                          </span>
                          <div className="student-learningside-assignment-meta-sec">
                            <span className="student-learningside-assignment-meta-item">
                              {" "}
                              • {item.total_questions} Questions
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* <Button
                      className="student-learningside-assignment-arrow-btn"
                      onClick={() => navigate("/student/assignment-detail")}
                    >
                      <span className="student-learningside-assignment-arrow-wrap">
                        <FaChevronRight />
                      </span>
                    </Button> */}
                    </div>
                  ))
                ) : (
                  <div className="student-assignments-empty">
                    <img
                      src={noDataAssignment}
                      alt="No Assignments"
                      className="student-assignments-empty-img"
                    />
                    <p className="student-assignments-empty-text">
                      Assignments will appear once you join a course
                    </p>
                  </div>
                )}
              </div>
            </Card>

            {/* YOUR MENTORS */}
            <Card className="student-learningside-card">
              <h6 className="student-learningside-title">Your Tutors</h6>

              <div className="student-learningside-mentors">
                {mentors.length > 0 ? (
                  mentors.map((mentor) => (
                    <div
                      key={`${mentor.user_id}-${mentor.course_id}`}
                      className="student-learningside-mentor-row"
                    >
                      <div className="student-learningside-avatar">
                        {initialsFromName(mentor.full_name)}
                      </div>

                      <div className="student-learningside-mentorinfo">
                        <p className="student-learningside-mentorname">
                          {mentor.full_name}
                        </p>
                        <span className="student-learningside-mentorrole">
                          {mentor.course_title}
                        </span>
                      </div>

                      {/* <Button className="student-learningside-arrowbtn">
                      <FaChevronRight className="student-learningside-arrowicon" />
                    </Button> */}
                    </div>
                  ))
                ) : (
                  <div className="student-assignments-empty">
                    <img
                      src={noDataAssignment}
                      alt="No Assignments"
                      className="student-assignments-empty-img"
                    />
                    <p className="student-assignments-empty-text">
                      No mentors assigned
                    </p>
                  </div>
                )}
              </div>
            </Card>

            <div className="student-learningside-card-chart">
              <h6 className="student-learningside-title ">
                Assignment Progress
              </h6>
              <Chart
                options={radialOptions}
                series={radialSeries}
                type="radialBar"
                height={260}
              />
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default StudentOverview;
